/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import CampaignControllerDtoAppDetailRequest from '../model/CampaignControllerDtoAppDetailRequest';
import CampaignControllerDtoAppDetailResponse from '../model/CampaignControllerDtoAppDetailResponse';
import CampaignControllerDtoAppListRequest from '../model/CampaignControllerDtoAppListRequest';
import CampaignControllerDtoAppListResponse from '../model/CampaignControllerDtoAppListResponse';
import CampaignControllerDtoAppRemoveRequest from '../model/CampaignControllerDtoAppRemoveRequest';
import CampaignControllerDtoAppRemoveResponse from '../model/CampaignControllerDtoAppRemoveResponse';
import CampaignControllerDtoAppSearchRequest from '../model/CampaignControllerDtoAppSearchRequest';
import CampaignControllerDtoAppSearchResponse from '../model/CampaignControllerDtoAppSearchResponse';
import CampaignControllerDtoAppUpdateRequest from '../model/CampaignControllerDtoAppUpdateRequest';
import CampaignControllerDtoAppUpdateResponse from '../model/CampaignControllerDtoAppUpdateResponse';
import CampaignControllerDtoAppVersionUpdateRequest from '../model/CampaignControllerDtoAppVersionUpdateRequest';
import CampaignControllerDtoCampaignDetailRequest from '../model/CampaignControllerDtoCampaignDetailRequest';
import CampaignControllerDtoCampaignDetailResponse from '../model/CampaignControllerDtoCampaignDetailResponse';
import CampaignControllerDtoCampaignListRequest from '../model/CampaignControllerDtoCampaignListRequest';
import CampaignControllerDtoCampaignListResponse from '../model/CampaignControllerDtoCampaignListResponse';
import CampaignControllerDtoCampaignLockStateRequest from '../model/CampaignControllerDtoCampaignLockStateRequest';
import CampaignControllerDtoCampaignRemoveRequest from '../model/CampaignControllerDtoCampaignRemoveRequest';
import CampaignControllerDtoCampaignSortRequest from '../model/CampaignControllerDtoCampaignSortRequest';
import CampaignControllerDtoCampaignTerminateRequest from '../model/CampaignControllerDtoCampaignTerminateRequest';
import CampaignControllerDtoCreateAppRequest from '../model/CampaignControllerDtoCreateAppRequest';
import CampaignControllerDtoCreateAppResponse from '../model/CampaignControllerDtoCreateAppResponse';
import CampaignControllerDtoPlayStoreSearchRequest from '../model/CampaignControllerDtoPlayStoreSearchRequest';
import CampaignControllerDtoPlayStoreSearchResponse from '../model/CampaignControllerDtoPlayStoreSearchResponse';
import CampaignControllerDtoResourceUpdateRequest from '../model/CampaignControllerDtoResourceUpdateRequest';
import CampaignControllerDtoWhiteListAddRequest from '../model/CampaignControllerDtoWhiteListAddRequest';
import CampaignControllerDtoWhiteListRemoveRequest from '../model/CampaignControllerDtoWhiteListRemoveRequest';
import GameType from '../model/GameType';

/**
* PerplayCampaign service.
* @module api/PerplayCampaignApi
* @version 1.0
*/
export default class PerplayCampaignApi {

    /**
    * Constructs a new PerplayCampaignApi. 
    * @alias module:api/PerplayCampaignApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayCampaignAppDetailPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignAppDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoAppDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoAppDetailRequest} [campaignControllerDtoAppDetailRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignAppDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoAppDetailResponse}
     */
    apiPerplayCampaignAppDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoAppDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoAppDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/AppDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignAppListPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignAppListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoAppListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoAppListRequest} [campaignControllerDtoAppListRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignAppListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoAppListResponse}
     */
    apiPerplayCampaignAppListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoAppListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoAppListResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/AppList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignAppRemovePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignAppRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoAppRemoveResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoAppRemoveRequest} [campaignControllerDtoAppRemoveRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignAppRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoAppRemoveResponse}
     */
    apiPerplayCampaignAppRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoAppRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoAppRemoveResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/AppRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignAppSearchPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignAppSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoAppSearchResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoAppSearchRequest} [campaignControllerDtoAppSearchRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignAppSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoAppSearchResponse}
     */
    apiPerplayCampaignAppSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoAppSearchRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoAppSearchResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/AppSearch', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignAppUpdatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignAppUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoAppUpdateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoAppUpdateRequest} [campaignControllerDtoAppUpdateRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignAppUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoAppUpdateResponse}
     */
    apiPerplayCampaignAppUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoAppUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoAppUpdateResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/AppUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignAppVersionUpdatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignAppVersionUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoAppVersionUpdateRequest} [campaignControllerDtoAppVersionUpdateRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignAppVersionUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignAppVersionUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoAppVersionUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/AppVersionUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignCreateAppPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignCreateAppPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoCreateAppResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCreateAppRequest} [campaignControllerDtoCreateAppRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignCreateAppPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoCreateAppResponse}
     */
    apiPerplayCampaignCreateAppPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCreateAppRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoCreateAppResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/CreateApp', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignPlayStoreSearchPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignPlayStoreSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoPlayStoreSearchResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoPlayStoreSearchRequest} [campaignControllerDtoPlayStoreSearchRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignPlayStoreSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoPlayStoreSearchResponse}
     */
    apiPerplayCampaignPlayStoreSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoPlayStoreSearchRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoPlayStoreSearchResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/PlayStoreSearch', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignRecommendedGameCreatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} campaignTitle 
     * @param {Date} startAt 
     * @param {Date} endAt 
     * @param {Number} appNo 
     * @param {String} campaignDesc 
     * @param {String} region 
     * @param {Number} needMinNftGrade 
     * @param {Number} needMinNftLevel 
     * @param {Number} needNftType 
     * @param {Number} needType 
     * @param {Object} opts Optional parameters
     * @param {File} [campaignLogoImage] 
     * @param {Number} [needValue] 
     * @param {Number} [initialPerDeposited] 
     * @param {Number} [dailyPerLeftover] 
     * @param {Number} [partnerWalletNo] 
     * @param {Number} [xperBasicPower] 
     * @param {Number} [miningXperDayLimit] 
     * @param {Number} [sortingIndex] 
     * @param {module:model/DepositTransactionStatusType} [depositTransactionStatus] 
     * @param {Boolean} [isLock] 
     * @param {Date} [createdAt] 
     * @param {Date} [updatedAt] 
     * @param {Number} [miningPerDayLimit] 
     * @param {Number} [usePowerDayLimit] 
     * @param {Number} [perOfBasicPower] 
     * @param {Number} [perBasicPower] 
     * @param {Number} [xperOfBasicPower] 
     * @param {Boolean} [x2eZone] 
     * @param {Boolean} [isAdvertised] 
     * @param {Boolean} [isEqualNftGrade] 
     * @param {Boolean} [isBasicMode] 
     * @param {String} [enableStartAt] 
     * @param {String} [enableEndAt] 
     * @param {Boolean} [plusFlag] 
     * @param {Number} [ticketId] 
     * @param {Number} [ticketCount] 
     * @param {module:model/GameType} [campaignType] 
     * @param {Number} [campaignNo] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignRecommendedGameCreatePost(campaignTitle, startAt, endAt, appNo, campaignDesc, region, needMinNftGrade, needMinNftLevel, needNftType, needType, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'campaignTitle' is set
      if (campaignTitle === undefined || campaignTitle === null) {
        throw new Error("Missing the required parameter 'campaignTitle' when calling apiPerplayCampaignRecommendedGameCreatePost");
      }
      // verify the required parameter 'startAt' is set
      if (startAt === undefined || startAt === null) {
        throw new Error("Missing the required parameter 'startAt' when calling apiPerplayCampaignRecommendedGameCreatePost");
      }
      // verify the required parameter 'endAt' is set
      if (endAt === undefined || endAt === null) {
        throw new Error("Missing the required parameter 'endAt' when calling apiPerplayCampaignRecommendedGameCreatePost");
      }
      // verify the required parameter 'appNo' is set
      if (appNo === undefined || appNo === null) {
        throw new Error("Missing the required parameter 'appNo' when calling apiPerplayCampaignRecommendedGameCreatePost");
      }
      // verify the required parameter 'campaignDesc' is set
      if (campaignDesc === undefined || campaignDesc === null) {
        throw new Error("Missing the required parameter 'campaignDesc' when calling apiPerplayCampaignRecommendedGameCreatePost");
      }
      // verify the required parameter 'region' is set
      if (region === undefined || region === null) {
        throw new Error("Missing the required parameter 'region' when calling apiPerplayCampaignRecommendedGameCreatePost");
      }
      // verify the required parameter 'needMinNftGrade' is set
      if (needMinNftGrade === undefined || needMinNftGrade === null) {
        throw new Error("Missing the required parameter 'needMinNftGrade' when calling apiPerplayCampaignRecommendedGameCreatePost");
      }
      // verify the required parameter 'needMinNftLevel' is set
      if (needMinNftLevel === undefined || needMinNftLevel === null) {
        throw new Error("Missing the required parameter 'needMinNftLevel' when calling apiPerplayCampaignRecommendedGameCreatePost");
      }
      // verify the required parameter 'needNftType' is set
      if (needNftType === undefined || needNftType === null) {
        throw new Error("Missing the required parameter 'needNftType' when calling apiPerplayCampaignRecommendedGameCreatePost");
      }
      // verify the required parameter 'needType' is set
      if (needType === undefined || needType === null) {
        throw new Error("Missing the required parameter 'needType' when calling apiPerplayCampaignRecommendedGameCreatePost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'CampaignTitle': campaignTitle,
        'StartAt': startAt,
        'EndAt': endAt,
        'AppNo': appNo,
        'CampaignDesc': campaignDesc,
        'Region': region,
        'NeedMinNftGrade': needMinNftGrade,
        'NeedMinNftLevel': needMinNftLevel,
        'NeedNftType': needNftType,
        'NeedType': needType,
        'CampaignLogoImage': opts['campaignLogoImage'],
        'NeedValue': opts['needValue'],
        'InitialPerDeposited': opts['initialPerDeposited'],
        'DailyPerLeftover': opts['dailyPerLeftover'],
        'PartnerWalletNo': opts['partnerWalletNo'],
        'XperBasicPower': opts['xperBasicPower'],
        'MiningXperDayLimit': opts['miningXperDayLimit'],
        'SortingIndex': opts['sortingIndex'],
        'DepositTransactionStatus': opts['depositTransactionStatus'],
        'IsLock': opts['isLock'],
        'CreatedAt': opts['createdAt'],
        'UpdatedAt': opts['updatedAt'],
        'MiningPerDayLimit': opts['miningPerDayLimit'],
        'UsePowerDayLimit': opts['usePowerDayLimit'],
        'PerOfBasicPower': opts['perOfBasicPower'],
        'PerBasicPower': opts['perBasicPower'],
        'XperOfBasicPower': opts['xperOfBasicPower'],
        'X2eZone': opts['x2eZone'],
        'IsAdvertised': opts['isAdvertised'],
        'IsEqualNftGrade': opts['isEqualNftGrade'],
        'IsBasicMode': opts['isBasicMode'],
        'EnableStartAt': opts['enableStartAt'],
        'EnableEndAt': opts['enableEndAt'],
        'PlusFlag': opts['plusFlag'],
        'TicketId': opts['ticketId'],
        'TicketCount': opts['ticketCount'],
        'CampaignType': opts['campaignType'],
        'CampaignNo': opts['campaignNo']
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/RecommendedGameCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignRecommendedGameDetailPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoCampaignDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignDetailRequest} [campaignControllerDtoCampaignDetailRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoCampaignDetailResponse}
     */
    apiPerplayCampaignRecommendedGameDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoCampaignDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/RecommendedGameDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignRecommendedGameListPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoCampaignListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignListRequest} [campaignControllerDtoCampaignListRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoCampaignListResponse}
     */
    apiPerplayCampaignRecommendedGameListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoCampaignListResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/RecommendedGameList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignRecommendedGameLockStatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameLockStatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignLockStateRequest} [campaignControllerDtoCampaignLockStateRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameLockStatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignRecommendedGameLockStatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignLockStateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/RecommendedGameLockState', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignRecommendedGameRemovePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignRemoveRequest} [campaignControllerDtoCampaignRemoveRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignRecommendedGameRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/RecommendedGameRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignRecommendedGameSortPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameSortPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignSortRequest} [campaignControllerDtoCampaignSortRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameSortPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignRecommendedGameSortPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignSortRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/RecommendedGameSort', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignRecommendedGameTerminatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameTerminatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignTerminateRequest} [campaignControllerDtoCampaignTerminateRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameTerminatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignRecommendedGameTerminatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignTerminateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/RecommendedGameTerminate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignRecommendedGameUpdatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} campaignNo 
     * @param {String} campaignTitle 
     * @param {Date} startAt 
     * @param {Date} endAt 
     * @param {Number} appNo 
     * @param {String} campaignDesc 
     * @param {String} region 
     * @param {Number} needMinNftGrade 
     * @param {Number} needMinNftLevel 
     * @param {Number} needNftType 
     * @param {Number} needType 
     * @param {Object} opts Optional parameters
     * @param {String} [enableStartAt] 
     * @param {String} [enableEndAt] 
     * @param {File} [campaignLogoImage] 
     * @param {Number} [needValue] 
     * @param {Number} [initialPerDeposited] 
     * @param {Number} [dailyPerLeftover] 
     * @param {Number} [partnerWalletNo] 
     * @param {Number} [xperBasicPower] 
     * @param {Number} [miningXperDayLimit] 
     * @param {Number} [sortingIndex] 
     * @param {module:model/DepositTransactionStatusType} [depositTransactionStatus] 
     * @param {Boolean} [isLock] 
     * @param {Date} [createdAt] 
     * @param {Date} [updatedAt] 
     * @param {Number} [miningPerDayLimit] 
     * @param {Number} [usePowerDayLimit] 
     * @param {Number} [perOfBasicPower] 
     * @param {Number} [perBasicPower] 
     * @param {Number} [xperOfBasicPower] 
     * @param {Boolean} [x2eZone] 
     * @param {Boolean} [isAdvertised] 
     * @param {Boolean} [isEqualNftGrade] 
     * @param {Boolean} [isBasicMode] 
     * @param {Boolean} [plusFlag] 
     * @param {Number} [ticketId] 
     * @param {Number} [ticketCount] 
     * @param {module:model/GameType} [campaignType] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignRecommendedGameUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignRecommendedGameUpdatePost(campaignNo, campaignTitle, startAt, endAt, appNo, campaignDesc, region, needMinNftGrade, needMinNftLevel, needNftType, needType, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'campaignNo' is set
      if (campaignNo === undefined || campaignNo === null) {
        throw new Error("Missing the required parameter 'campaignNo' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }
      // verify the required parameter 'campaignTitle' is set
      if (campaignTitle === undefined || campaignTitle === null) {
        throw new Error("Missing the required parameter 'campaignTitle' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }
      // verify the required parameter 'startAt' is set
      if (startAt === undefined || startAt === null) {
        throw new Error("Missing the required parameter 'startAt' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }
      // verify the required parameter 'endAt' is set
      if (endAt === undefined || endAt === null) {
        throw new Error("Missing the required parameter 'endAt' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }
      // verify the required parameter 'appNo' is set
      if (appNo === undefined || appNo === null) {
        throw new Error("Missing the required parameter 'appNo' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }
      // verify the required parameter 'campaignDesc' is set
      if (campaignDesc === undefined || campaignDesc === null) {
        throw new Error("Missing the required parameter 'campaignDesc' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }
      // verify the required parameter 'region' is set
      if (region === undefined || region === null) {
        throw new Error("Missing the required parameter 'region' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }
      // verify the required parameter 'needMinNftGrade' is set
      if (needMinNftGrade === undefined || needMinNftGrade === null) {
        throw new Error("Missing the required parameter 'needMinNftGrade' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }
      // verify the required parameter 'needMinNftLevel' is set
      if (needMinNftLevel === undefined || needMinNftLevel === null) {
        throw new Error("Missing the required parameter 'needMinNftLevel' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }
      // verify the required parameter 'needNftType' is set
      if (needNftType === undefined || needNftType === null) {
        throw new Error("Missing the required parameter 'needNftType' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }
      // verify the required parameter 'needType' is set
      if (needType === undefined || needType === null) {
        throw new Error("Missing the required parameter 'needType' when calling apiPerplayCampaignRecommendedGameUpdatePost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'CampaignNo': campaignNo,
        'CampaignTitle': campaignTitle,
        'StartAt': startAt,
        'EndAt': endAt,
        'EnableStartAt': opts['enableStartAt'],
        'EnableEndAt': opts['enableEndAt'],
        'AppNo': appNo,
        'CampaignDesc': campaignDesc,
        'Region': region,
        'NeedMinNftGrade': needMinNftGrade,
        'NeedMinNftLevel': needMinNftLevel,
        'NeedNftType': needNftType,
        'NeedType': needType,
        'CampaignLogoImage': opts['campaignLogoImage'],
        'NeedValue': opts['needValue'],
        'InitialPerDeposited': opts['initialPerDeposited'],
        'DailyPerLeftover': opts['dailyPerLeftover'],
        'PartnerWalletNo': opts['partnerWalletNo'],
        'XperBasicPower': opts['xperBasicPower'],
        'MiningXperDayLimit': opts['miningXperDayLimit'],
        'SortingIndex': opts['sortingIndex'],
        'DepositTransactionStatus': opts['depositTransactionStatus'],
        'IsLock': opts['isLock'],
        'CreatedAt': opts['createdAt'],
        'UpdatedAt': opts['updatedAt'],
        'MiningPerDayLimit': opts['miningPerDayLimit'],
        'UsePowerDayLimit': opts['usePowerDayLimit'],
        'PerOfBasicPower': opts['perOfBasicPower'],
        'PerBasicPower': opts['perBasicPower'],
        'XperOfBasicPower': opts['xperOfBasicPower'],
        'X2eZone': opts['x2eZone'],
        'IsAdvertised': opts['isAdvertised'],
        'IsEqualNftGrade': opts['isEqualNftGrade'],
        'IsBasicMode': opts['isBasicMode'],
        'PlusFlag': opts['plusFlag'],
        'TicketId': opts['ticketId'],
        'TicketCount': opts['ticketCount'],
        'CampaignType': opts['campaignType']
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/RecommendedGameUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignResourceUpdatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignResourceUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoResourceUpdateRequest} [campaignControllerDtoResourceUpdateRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignResourceUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignResourceUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoResourceUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/ResourceUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignSpecialGameCreatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} campaignTitle 
     * @param {Date} startAt 
     * @param {Date} endAt 
     * @param {Number} appNo 
     * @param {String} campaignDesc 
     * @param {String} region 
     * @param {Number} needMinNftGrade 
     * @param {Number} needMinNftLevel 
     * @param {Number} needNftType 
     * @param {Number} needType 
     * @param {Object} opts Optional parameters
     * @param {File} [campaignLogoImage] 
     * @param {Number} [needValue] 
     * @param {Number} [initialPerDeposited] 
     * @param {Number} [dailyPerLeftover] 
     * @param {Number} [partnerWalletNo] 
     * @param {Number} [xperBasicPower] 
     * @param {Number} [miningXperDayLimit] 
     * @param {Number} [sortingIndex] 
     * @param {module:model/DepositTransactionStatusType} [depositTransactionStatus] 
     * @param {Boolean} [isLock] 
     * @param {Date} [createdAt] 
     * @param {Date} [updatedAt] 
     * @param {Number} [miningPerDayLimit] 
     * @param {Number} [usePowerDayLimit] 
     * @param {Number} [perOfBasicPower] 
     * @param {Number} [perBasicPower] 
     * @param {Number} [xperOfBasicPower] 
     * @param {Boolean} [x2eZone] 
     * @param {Boolean} [isAdvertised] 
     * @param {Boolean} [isEqualNftGrade] 
     * @param {Boolean} [isBasicMode] 
     * @param {String} [enableStartAt] 
     * @param {String} [enableEndAt] 
     * @param {Boolean} [plusFlag] 
     * @param {Number} [ticketId] 
     * @param {Number} [ticketCount] 
     * @param {module:model/GameType} [campaignType] 
     * @param {Number} [campaignNo] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignSpecialGameCreatePost(campaignTitle, startAt, endAt, appNo, campaignDesc, region, needMinNftGrade, needMinNftLevel, needNftType, needType, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'campaignTitle' is set
      if (campaignTitle === undefined || campaignTitle === null) {
        throw new Error("Missing the required parameter 'campaignTitle' when calling apiPerplayCampaignSpecialGameCreatePost");
      }
      // verify the required parameter 'startAt' is set
      if (startAt === undefined || startAt === null) {
        throw new Error("Missing the required parameter 'startAt' when calling apiPerplayCampaignSpecialGameCreatePost");
      }
      // verify the required parameter 'endAt' is set
      if (endAt === undefined || endAt === null) {
        throw new Error("Missing the required parameter 'endAt' when calling apiPerplayCampaignSpecialGameCreatePost");
      }
      // verify the required parameter 'appNo' is set
      if (appNo === undefined || appNo === null) {
        throw new Error("Missing the required parameter 'appNo' when calling apiPerplayCampaignSpecialGameCreatePost");
      }
      // verify the required parameter 'campaignDesc' is set
      if (campaignDesc === undefined || campaignDesc === null) {
        throw new Error("Missing the required parameter 'campaignDesc' when calling apiPerplayCampaignSpecialGameCreatePost");
      }
      // verify the required parameter 'region' is set
      if (region === undefined || region === null) {
        throw new Error("Missing the required parameter 'region' when calling apiPerplayCampaignSpecialGameCreatePost");
      }
      // verify the required parameter 'needMinNftGrade' is set
      if (needMinNftGrade === undefined || needMinNftGrade === null) {
        throw new Error("Missing the required parameter 'needMinNftGrade' when calling apiPerplayCampaignSpecialGameCreatePost");
      }
      // verify the required parameter 'needMinNftLevel' is set
      if (needMinNftLevel === undefined || needMinNftLevel === null) {
        throw new Error("Missing the required parameter 'needMinNftLevel' when calling apiPerplayCampaignSpecialGameCreatePost");
      }
      // verify the required parameter 'needNftType' is set
      if (needNftType === undefined || needNftType === null) {
        throw new Error("Missing the required parameter 'needNftType' when calling apiPerplayCampaignSpecialGameCreatePost");
      }
      // verify the required parameter 'needType' is set
      if (needType === undefined || needType === null) {
        throw new Error("Missing the required parameter 'needType' when calling apiPerplayCampaignSpecialGameCreatePost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'CampaignTitle': campaignTitle,
        'StartAt': startAt,
        'EndAt': endAt,
        'AppNo': appNo,
        'CampaignDesc': campaignDesc,
        'Region': region,
        'NeedMinNftGrade': needMinNftGrade,
        'NeedMinNftLevel': needMinNftLevel,
        'NeedNftType': needNftType,
        'NeedType': needType,
        'CampaignLogoImage': opts['campaignLogoImage'],
        'NeedValue': opts['needValue'],
        'InitialPerDeposited': opts['initialPerDeposited'],
        'DailyPerLeftover': opts['dailyPerLeftover'],
        'PartnerWalletNo': opts['partnerWalletNo'],
        'XperBasicPower': opts['xperBasicPower'],
        'MiningXperDayLimit': opts['miningXperDayLimit'],
        'SortingIndex': opts['sortingIndex'],
        'DepositTransactionStatus': opts['depositTransactionStatus'],
        'IsLock': opts['isLock'],
        'CreatedAt': opts['createdAt'],
        'UpdatedAt': opts['updatedAt'],
        'MiningPerDayLimit': opts['miningPerDayLimit'],
        'UsePowerDayLimit': opts['usePowerDayLimit'],
        'PerOfBasicPower': opts['perOfBasicPower'],
        'PerBasicPower': opts['perBasicPower'],
        'XperOfBasicPower': opts['xperOfBasicPower'],
        'X2eZone': opts['x2eZone'],
        'IsAdvertised': opts['isAdvertised'],
        'IsEqualNftGrade': opts['isEqualNftGrade'],
        'IsBasicMode': opts['isBasicMode'],
        'EnableStartAt': opts['enableStartAt'],
        'EnableEndAt': opts['enableEndAt'],
        'PlusFlag': opts['plusFlag'],
        'TicketId': opts['ticketId'],
        'TicketCount': opts['ticketCount'],
        'CampaignType': opts['campaignType'],
        'CampaignNo': opts['campaignNo']
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/SpecialGameCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignSpecialGameDetailPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoCampaignDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignDetailRequest} [campaignControllerDtoCampaignDetailRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoCampaignDetailResponse}
     */
    apiPerplayCampaignSpecialGameDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoCampaignDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/SpecialGameDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignSpecialGameListPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignControllerDtoCampaignListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignListRequest} [campaignControllerDtoCampaignListRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignControllerDtoCampaignListResponse}
     */
    apiPerplayCampaignSpecialGameListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CampaignControllerDtoCampaignListResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/SpecialGameList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignSpecialGameLockStatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameLockStatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignLockStateRequest} [campaignControllerDtoCampaignLockStateRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameLockStatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignSpecialGameLockStatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignLockStateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/SpecialGameLockState', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignSpecialGameRemovePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignRemoveRequest} [campaignControllerDtoCampaignRemoveRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignSpecialGameRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/SpecialGameRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignSpecialGameSortPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameSortPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignSortRequest} [campaignControllerDtoCampaignSortRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameSortPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignSpecialGameSortPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignSortRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/SpecialGameSort', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignSpecialGameTerminatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameTerminatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoCampaignTerminateRequest} [campaignControllerDtoCampaignTerminateRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameTerminatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignSpecialGameTerminatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoCampaignTerminateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/SpecialGameTerminate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignSpecialGameUpdatePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} campaignNo 
     * @param {String} campaignTitle 
     * @param {Date} startAt 
     * @param {Date} endAt 
     * @param {Number} appNo 
     * @param {String} campaignDesc 
     * @param {String} region 
     * @param {Number} needMinNftGrade 
     * @param {Number} needMinNftLevel 
     * @param {Number} needNftType 
     * @param {Number} needType 
     * @param {Object} opts Optional parameters
     * @param {String} [enableStartAt] 
     * @param {String} [enableEndAt] 
     * @param {File} [campaignLogoImage] 
     * @param {Number} [needValue] 
     * @param {Number} [initialPerDeposited] 
     * @param {Number} [dailyPerLeftover] 
     * @param {Number} [partnerWalletNo] 
     * @param {Number} [xperBasicPower] 
     * @param {Number} [miningXperDayLimit] 
     * @param {Number} [sortingIndex] 
     * @param {module:model/DepositTransactionStatusType} [depositTransactionStatus] 
     * @param {Boolean} [isLock] 
     * @param {Date} [createdAt] 
     * @param {Date} [updatedAt] 
     * @param {Number} [miningPerDayLimit] 
     * @param {Number} [usePowerDayLimit] 
     * @param {Number} [perOfBasicPower] 
     * @param {Number} [perBasicPower] 
     * @param {Number} [xperOfBasicPower] 
     * @param {Boolean} [x2eZone] 
     * @param {Boolean} [isAdvertised] 
     * @param {Boolean} [isEqualNftGrade] 
     * @param {Boolean} [isBasicMode] 
     * @param {Boolean} [plusFlag] 
     * @param {Number} [ticketId] 
     * @param {Number} [ticketCount] 
     * @param {module:model/GameType} [campaignType] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignSpecialGameUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignSpecialGameUpdatePost(campaignNo, campaignTitle, startAt, endAt, appNo, campaignDesc, region, needMinNftGrade, needMinNftLevel, needNftType, needType, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'campaignNo' is set
      if (campaignNo === undefined || campaignNo === null) {
        throw new Error("Missing the required parameter 'campaignNo' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }
      // verify the required parameter 'campaignTitle' is set
      if (campaignTitle === undefined || campaignTitle === null) {
        throw new Error("Missing the required parameter 'campaignTitle' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }
      // verify the required parameter 'startAt' is set
      if (startAt === undefined || startAt === null) {
        throw new Error("Missing the required parameter 'startAt' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }
      // verify the required parameter 'endAt' is set
      if (endAt === undefined || endAt === null) {
        throw new Error("Missing the required parameter 'endAt' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }
      // verify the required parameter 'appNo' is set
      if (appNo === undefined || appNo === null) {
        throw new Error("Missing the required parameter 'appNo' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }
      // verify the required parameter 'campaignDesc' is set
      if (campaignDesc === undefined || campaignDesc === null) {
        throw new Error("Missing the required parameter 'campaignDesc' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }
      // verify the required parameter 'region' is set
      if (region === undefined || region === null) {
        throw new Error("Missing the required parameter 'region' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }
      // verify the required parameter 'needMinNftGrade' is set
      if (needMinNftGrade === undefined || needMinNftGrade === null) {
        throw new Error("Missing the required parameter 'needMinNftGrade' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }
      // verify the required parameter 'needMinNftLevel' is set
      if (needMinNftLevel === undefined || needMinNftLevel === null) {
        throw new Error("Missing the required parameter 'needMinNftLevel' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }
      // verify the required parameter 'needNftType' is set
      if (needNftType === undefined || needNftType === null) {
        throw new Error("Missing the required parameter 'needNftType' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }
      // verify the required parameter 'needType' is set
      if (needType === undefined || needType === null) {
        throw new Error("Missing the required parameter 'needType' when calling apiPerplayCampaignSpecialGameUpdatePost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'CampaignNo': campaignNo,
        'CampaignTitle': campaignTitle,
        'StartAt': startAt,
        'EndAt': endAt,
        'EnableStartAt': opts['enableStartAt'],
        'EnableEndAt': opts['enableEndAt'],
        'AppNo': appNo,
        'CampaignDesc': campaignDesc,
        'Region': region,
        'NeedMinNftGrade': needMinNftGrade,
        'NeedMinNftLevel': needMinNftLevel,
        'NeedNftType': needNftType,
        'NeedType': needType,
        'CampaignLogoImage': opts['campaignLogoImage'],
        'NeedValue': opts['needValue'],
        'InitialPerDeposited': opts['initialPerDeposited'],
        'DailyPerLeftover': opts['dailyPerLeftover'],
        'PartnerWalletNo': opts['partnerWalletNo'],
        'XperBasicPower': opts['xperBasicPower'],
        'MiningXperDayLimit': opts['miningXperDayLimit'],
        'SortingIndex': opts['sortingIndex'],
        'DepositTransactionStatus': opts['depositTransactionStatus'],
        'IsLock': opts['isLock'],
        'CreatedAt': opts['createdAt'],
        'UpdatedAt': opts['updatedAt'],
        'MiningPerDayLimit': opts['miningPerDayLimit'],
        'UsePowerDayLimit': opts['usePowerDayLimit'],
        'PerOfBasicPower': opts['perOfBasicPower'],
        'PerBasicPower': opts['perBasicPower'],
        'XperOfBasicPower': opts['xperOfBasicPower'],
        'X2eZone': opts['x2eZone'],
        'IsAdvertised': opts['isAdvertised'],
        'IsEqualNftGrade': opts['isEqualNftGrade'],
        'IsBasicMode': opts['isBasicMode'],
        'PlusFlag': opts['plusFlag'],
        'TicketId': opts['ticketId'],
        'TicketCount': opts['ticketCount'],
        'CampaignType': opts['campaignType']
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/SpecialGameUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignWhiteListAddPost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignWhiteListAddPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoWhiteListAddRequest} [campaignControllerDtoWhiteListAddRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignWhiteListAddPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignWhiteListAddPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoWhiteListAddRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/WhiteListAdd', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCampaignWhiteListRemovePost operation.
     * @callback module:api/PerplayCampaignApi~apiPerplayCampaignWhiteListRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CampaignControllerDtoWhiteListRemoveRequest} [campaignControllerDtoWhiteListRemoveRequest] 
     * @param {module:api/PerplayCampaignApi~apiPerplayCampaignWhiteListRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCampaignWhiteListRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['campaignControllerDtoWhiteListRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCampaign/WhiteListRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
